/**
 * Define all ASuite routes as enum.
 */
export enum SiteRoute {
  Dashboard = "/",
  Admin = "/admin",
  Error = "/404",

  // Public
  Login = "/login",
}

// Define all "Authenticated" views, i.e. views
// rendered inside the ASuite dashboard.
export enum SiteView {
  Dashboard = SiteRoute.Dashboard,
  Admin = SiteRoute.Admin,
}

export interface AppViewConfig {
  view: SiteView;
  name: string;
  admin: boolean;
}

export class Site {
  // Website
  public static web: string = "https://cloud.eningo.se";

  // Routes

  /**
   * Check that the given route, r, is a public route.
   * @param r
   */
  public static inPublicRoutes = (r: string): boolean => {
    const pubRoutes: string[] = [SiteRoute.Error, SiteRoute.Login];
    return pubRoutes.includes(r);
  };

  /**
   * Check that the given route, r, is a private route.
   * I.e., route accessing requires authenticated user session.
   * @param r
   */
  public static inPrivateRoutes = (r: string): boolean => {
    const privRoutes: string[] = [SiteRoute.Dashboard];
    return privRoutes.includes(r);
  };

  // Check route is valid, otherwise "404" status.
  public static routeExists = (r: string): boolean =>
    Site.inPrivateRoutes(r) || Site.inPublicRoutes(r);

  // Views
  public static AppViews = class {
    // Define configurations for
    // views in ASuite authenticated state
    // application.

    static Dashboard: AppViewConfig = {
      view: SiteView.Dashboard,
      name: "Dashboard",
      admin: false,
    };
    static Admin: AppViewConfig = {
      view: SiteView.Admin,
      name: "Admin",
      admin: false,
    };
    public static all = (): AppViewConfig[] => {
      return [Site.AppViews.Dashboard];
    };
  };
}
